<div class="cv-page">
  <div
    class="cv-1"
    [ngClass]="{ 'thumbnail-view': isThumbnail, 'full-view': !isThumbnail }"
  >
    <div class="nameAddress">
      <h2 class="fullName">{{ data.firstName }} {{ data.lastName }}</h2>
      <p
        *ngIf="data.designation"
        class="designation"
      >
        {{ data.designation }}
      </p>
      <div class="address">
        <p *ngIf="data.contactDetails.number">
          <img
            src="../../../../../assets/images/grey-phone-icon.webp"
            alt="Phone"
            class="icon"
          />
          {{ data.contactDetails.number }}
        </p>
        <p *ngIf="data.contactDetails.email">
          <img
            src="../../../../../assets/images/grey-envelope-icon.webp"
            alt="Mail"
            class="icon"
          />
          {{ data.contactDetails.email }}
        </p>
        <p *ngIf="data.contactDetails.address">
          <img
            src="../../../../../assets/images/grey-pin-icon.webp"
            alt="Location"
            class="icon"
          />
          {{ data.contactDetails.address }}
        </p>
        <p *ngIf="data.contactDetails.linkedIn">
          <img
            src="../../../../../assets/images/grey-linkedin-icon.webp"
            alt="LinkedIn"
            class="icon"
          />
          {{ data.contactDetails.linkedIn }}
        </p>
      </div>
    </div>
    <div class="experience-div">
      <h3>EXPERIENCE</h3>
      <div
        class="experience-section"
        *ngFor="let exp of data.experience"
      >
        <div class="company-place">
          <h4 class="company-name">{{ exp.company }}</h4>
          <p
            class="company-place"
            *ngIf="exp.joblocation.City || exp.joblocation.State"
          >
            {{ exp.joblocation.City }}, {{ exp.joblocation.State }}
          </p>
        </div>
        <div class="title-date">
          <h4 class="job-title">{{ exp.Title }}</h4>
          <p class="dates">
            {{ exp.startDate }} - {{ exp.endDate ? exp.endDate : ' Present' }}
          </p>
        </div>
        <ul class="description-points">
          <li *ngFor="let point of exp.descriptionPoints">
            {{ point }}
          </li>
        </ul>
      </div>
    </div>
    <div class="education-div">
      <h3>EDUCATION</h3>
      <div
        *ngFor="let edu of data.educations"
        class="education-item"
      >
        <p class="degree-name">{{ edu.courseName }}</p>
        <div class="uni-date">
          <p class="uni-name">{{ edu.universityName }}</p>
          <p class="timeline">{{ edu.formattedDate }}</p>
        </div>
      </div>
    </div>
    <div class="skills-div">
      <h3>SKILLS</h3>
      <ul class="skills">
        <ng-container *ngFor="let row of skillsInRows">
          <li
            *ngFor="let skill of row"
            style="display: inline-block; width: 70%"
          >
            {{ skill }}
          </li>
        </ng-container>
      </ul>
    </div>
    <div
      class="ceritications-div"
      *ngIf="data.certifications.length !== 0"
    >
      <h3>CERTIFICATES</h3>
      <div class="certifications">
        <div
          class="certification-item"
          *ngFor="let cer of data.certifications"
        >
          <p class="issue-authority">
            <span *ngIf="cer.authority"
              ><b>{{ cer.authority }}: </b></span
            >
            <span *ngIf="cer.name">{{ cer.name }}</span>
            <span *ngIf="cer.date">({{ cer.date }})</span>
          </p>
        </div>
      </div>
    </div>
    <div
      class="language-div"
      *ngIf="data.languages"
    >
      <h3>LANGUAGES</h3>
      <div class="language-item">
        <ul class="language-skills">
          <li *ngFor="let lang of data.languages">
            {{ lang }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
